window.addEventListener('load',()=>{
    const fraction = document.getElementById("fraction");

    var galleryThumbs = new Swiper(".gallery-thumbs", {
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: 'vertical'
    });
    
    var galleryMain = new Swiper(".gallery-main", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: ".swiper-pagination"
      },
      thumbs: {
        swiper: galleryThumbs
      },
      on: {
        slideChange: () => {
            fraction.textContent = `${galleryMain.realIndex + 1}/${slideCount}`;
            let slideElem = document.querySelector(`.gallery-main .swiper-slide[data-index="${galleryMain.realIndex + 1}"]`);
            if(slideElem){
              let type = slideElem.getAttribute('data-media-type');
              console.log(slideElem,type)
              if(type == 'video'){
                let video = slideElem.querySelector('video');
                if(video.paused){
                  video.play();
                }
              }
            }
        }
      }
    });
    
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
    });

    // ADD SLIDE COUNT PAGINATION
    const slideCount = galleryMain.slides.length;
    fraction.textContent = `1/${slideCount}`;
    
    // galleryThumbs.on('transitionStart', function(){
    //   galleryMain.slideTo(galleryThumbs.activeIndex);
    // });



    // CLOSE LIGHT BOX
    let lightBox = document.querySelector('.lightbox-gallery');
    let closeBtn = document.querySelector('.lightbox-gallery__close');
    if(closeBtn && lightBox){
        closeBtn.addEventListener('click',()=>{
            lightBox.classList.remove('open');
        })
    }

    // OPEN LIGHTBOX
    let mainSlides = document.querySelectorAll('.slider-galeria_slide');
    if(mainSlides.length > 0){
        mainSlides.forEach((slide)=>{
            

            let isDragging = false;

            const draggableElement = slide;

            draggableElement.addEventListener('mousedown', (event) => {
            isDragging = false;

            const onMouseMove = () => {
                isDragging = true;
            };

            const onMouseUp = () => {
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            };

            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
            });

            draggableElement.addEventListener('click', (event) => {
                console.log(isDragging);
            if (isDragging) {
                event.preventDefault();
                isDragging = false;
            } else {
                if(lightBox){
                    let id = +slide.getAttribute('data-slick-index');
                    console.log(galleryMain);
                    galleryMain.slideTo(id);
                    lightBox.classList.add('open');
                }
            }
            });



        })
    }
  })